import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button, Drawer, Modal, Alert, Tooltip, Tag } from "antd";
import { message } from "components/UI/AntdAppHelper";
import { removeItemFromArray } from "views/Segments/InteractiveHelpers";
import SelectFromComputer from "components/UI/Media/SelectFromComputer";
import ThumbnailAttachments from "components/UI/Attachments/ThumbnailAttachments/ThumbnailAttachments";
import PreviewAttachment from "components/UI/Attachments/PreviewAttachment";
import { cloneDeep } from "lodash";
import { checkIPAD, checkMob, getLabelFromIndexPath, getUniqueId } from "lib/utils/helperMethods";
import Compressor from "compressorjs";
import { actions as experienceUserActions } from "views/ExperienceUsers/redux";
import { activeAdjustedExperienceSelector, experienceViewModeSelector, getInternetStatusSelector } from "views/Experiences/selector";
import { currentUserSelector } from "views/Auth/Login/selector";
import { DownloadOutlined, UndoOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { formatJsonApiData } from "mr_react_framework";
import { showConfirmModal } from "components/UI/Segment/UIHelper";
import  "./ResponseAttachments.scss";
import { activeExperienceUserSelector } from "views/ExperienceUsers/selector";
import { MdRestore } from "react-icons/md";
import MrTranslate, { useTranslate } from "lib/MrTranslate/MrTranslate";

const ReopenUploads = (props) => {
  const { disabled } = props
  const activeExperience = useSelector(activeAdjustedExperienceSelector())
  const experienceSettings = activeExperience.settings || {};
  const currentUser = useSelector(currentUserSelector())
  const experienceUser = useSelector(activeExperienceUserSelector())
  const dispatch = useDispatch()
  const mrIntl = useTranslate()
  let isAllowStudentUploadFiles = experienceSettings.allow_student_upload_files;

  const showUploadBtnConfirm = () => {
    showConfirmModal({
      title: mrIntl("ResponseAttachments.are_you_sure_you_want_to_allow_more_uploads_from_student"),
      icon: <ExclamationCircleOutlined />,
      okText: mrIntl("CommonText.ok"),
      cancelText: mrIntl("CommonText.cancel"),
      okType: "primary",
      content: mrIntl("ResponseAttachments.this_will_allow_the_student_to_upload_extra_files"),
      onOk() {
        console.log("OK");
        dispatch(
          experienceUserActions.retakeExperience(
            { experienceUser: experienceUser },
            {
              successCallback: (response) => {
                const updatedExperienceUser = {
                  ...experienceUser,
                  uploads_allowed: true,
                };

                dispatch(
                  experienceUserActions.showSuccess(
                    { data: { experience_user: updatedExperienceUser } },
                    { success: { showMessage: false } }
                  )
                );
              },
            }
          )
        );
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  return <>
    <Tooltip title={
      activeExperience.status === "closed"
        ? mrIntl("ResponseAttachments.published_assessment_then_reopen_uploads")
        : disabled ? mrIntl("ResponseAttachments.unpublished_result_to_reopen_upload") : mrIntl("ResponseAttachments.reopen_uploads_title")
    }>
      {(currentUser.role === "admin" ||
        (currentUser.role === "teacher" &&
          currentUser.permission.experience_user &&
          currentUser.permission.experience_user.reset === true)) &&
        isAllowStudentUploadFiles && (<Button
          key="menu-item-reopen-uploads"
          className="reopen-upload-button"
          icon={<MdRestore />}
          onClick={() => {
            showUploadBtnConfirm();
          }}
          disabled={activeExperience.status === "closed" || disabled}
        />)}
    </Tooltip>
  </>
}
const internetStatusSelector = getInternetStatusSelector();
const ResponseAttachments = (props) => {
  console.log("Response attachments props ==>", props)
  const {
    answerMode,
    modalVisible,
    closeModal,
    previewType,
    presentationMode,
    attempt_status = {},
    maxAttachments,
    gradingEnabled,
    experienceSettings = {},
    screenSettings,
    parentIdxs,
    disableUploader = false,
    disabledUploaderTooltip
  } = props;

  let attemptStatusObject = {
    files_uploaded: attempt_status.files_uploaded || 0,
    files_upload_attempted: attempt_status.files_upload_attempted || false,
  };

  const internetStatus = useSelector(internetStatusSelector);
  const currentUser = useSelector(currentUserSelector())
  const experienceUser = useSelector(activeExperienceUserSelector());
  const mrIntl = useTranslate()
  const [state, setState] = useState(cloneDeep(props.attachments_json));
  const [stateUpdatedCount, setStateUpdatedCount] = useState(0);
  const [attemptStatus, setAttemptStatus] = useState(attemptStatusObject);

  let attachments_json;
  if (presentationMode) {
    attachments_json = props.attachments_json || {};
  } else {
    attachments_json = state || {};
  }

  const attachments = attachments_json.attachments || [];
  const removedAttachments = attachments_json.removedAttachments || [];

  const [stateSetting, setStateSetting] = useState({
    updatedCount: 0,
  });

  const user_id = props.userId || currentUser.id
  const isMobile = checkMob()
  const isIPAD = checkIPAD()
  const experienceViewMode = useSelector(experienceViewModeSelector())
  let mediaFormInitialState = {
    id: props.id,
    modal: false,
    loading: false,
    visible: false,
    title: mrIntl("ResponseAttachments.insert_attachments_title"),
    okText: mrIntl("CommonText.save"),
    cancelText: mrIntl("CommonText.cancel"),
    triggerSaveAction: 0,
    requireFooter: false,
    content_type: "image",
    supportedTypes:
      "image/jpg, image/jpeg, image/png, image/gif, image/bmp, application/pdf",
    supportedFormats: "jpg, jpeg, png, gif, bmp, pdf",
    limit: maxAttachments || 25,
    deleteNotAllowedMessage: props.deleteNotAllowedMessage || "",
    currentFileIndex: 0,
    extraParams: `save_record=true&user_id=${user_id}&record_type=Experience&record_id=${props.recordId}&upload_type=${props.uploadType}`,
    selectConfig: {
      hide_uploader:
        experienceViewMode == "apTakeTest" &&
        experienceSettings.mode != "online" &&
        !isMobile &&
        !isIPAD
          ? true
          : false,
      // experienceViewMode === "apTakeTest"
      // ? (experienceSettings.mode == "online" || (experienceSettings.mode != "online" && (isMobile || checkIPAD())))
      // ? false
      // : true
      // : false,
      disabled: disableUploader,
      disabledUploaderTooltip: disableUploader && disabledUploaderTooltip,
      type: "pictures-wall",
      overrideUploadList: false,
      defaultFileList: attachments.slice().map((atc) => {
        if (props.deleteNotAllowedMessage) {
          atc.notDeletable = true;
        }
        return atc;
      }),
      maxSize: "20 MB",
      multiple: false,
      transformFile: (file) => {
        return new Promise((resolve) => {
          new Compressor(file, {
            quality: 0.6,
            success(result) {
              console.log("Compressor resolve file ==>", result);
              resolve(result);
            },
            error(err) {
              console.log(err.message);
              resolve(file);
            },
          });
        });
      },
    },
    // onPreview: async file => {
    //   let src = file.url;
    //   if (!src) {
    //     src = await new Promise(resolve => {
    //       const reader = new FileReader();
    //       reader.readAsDataURL(file.originFileObj);
    //       reader.onload = () => resolve(reader.result);
    //     });
    //   }

    //   setMediaFormSetting({
    //     ...mediaFormSetting,
    //     previewCurrentFile: {
    //       ...file,
    //       url: src
    //     }
    //   })
    // },
    // onChangeSaveFiles: (files) => {
    //   console.log("on change files ==>", files)
    //   const newFiles = files
    //   onSaveMedia(newFiles)
    // },
    // onRemoveFile: (file) => {
    //   onRemoveMedia(file)
    // },
    // onDragEnd: (result) => {
    //   return onMediaOrderChange(result)
    // }
  };


  if (isIPAD && ["online_secure", "offline"].includes(experienceSettings.mode)) {
    mediaFormInitialState = {
      ...mediaFormInitialState,
      selectConfig: {
        ...mediaFormInitialState.selectConfig,
        accept: "image/x-png,image/jpeg", // accept will allow the capture image option on native camera otherwise will allow the video also
        capture: "environment",
      },
    };
  }

  const [mediaFormSetting, setMediaFormSetting] = useState(
    mediaFormInitialState
  );

  // mediaFormSetting.previewCurrentFile = (file) => {
  //   console.log("Preview file ===>", file)
  //   return file.url
  // }

  mediaFormSetting.previewFile = (file) => {
    return file;
  };
  
  mediaFormSetting.onPreview = async (file, value) => {
    if (props.onPreview) {
      props.onPreview()
    } else {
      console.log("value and file", value, file);
      let src = file.url;
      if (!src) {
        src = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file.originFileObj);
          reader.onload = () => resolve(reader.result);
        });
      }

      setMediaFormSetting({
        ...mediaFormSetting,
        previewCurrentFile: {
          ...file,
          url: src,
        },
      });
    }
  };

  mediaFormSetting.onChangeSaveFiles = (files) => {
    console.log("on change files ==>", files);
    const { newFiles, extraFiles } = beforeSave(files);
    onSaveMedia(newFiles, extraFiles);
  };

  mediaFormSetting.onRemoveFile = (file) => {
    onRemoveMedia(file);
  };

  mediaFormSetting.onDragEnd = (result) => {
    return onMediaOrderChange(result);
  };

  const beforeSave = (files) => {
    let newFiles = [];
    let extraFiles = [];
    let { segment_id, topic_id, activeTopicIdx, qNo, parentIdxs } = props;
    files.map((file) => {
      file["upload_type"] =
        segment_id || file["segment_id"] ? "QuestionWise" : "ExperienceWise";
      if (segment_id) {
        file["topic_id"] = topic_id;
        file["segment_id"] = segment_id;
        // file["question_index"] = qNo - 1;
        file["topic_index"] = activeTopicIdx;
        // file["segment_index_label"] = getLabelFromIndexPath(parentIdxs)
        file["segment_index_path"] = parentIdxs
      }
      if (
        file.type &&
        file.type.indexOf("pdf") >= 0 &&
        file.page_urls &&
        false
      ) {
        // disabling conversion during upload - only after submission
        extraFiles.push(file);
        file.page_urls.map((page) => {
          page["topic_id"] = topic_id;
          page["segment_id"] = segment_id;
          page["upload_type"] = segment_id ? "QuestionWise" : "ExperienceWise";
          newFiles.push(page);
        });
      } else {
        newFiles.push(file);
      }

      console.log(
        "uploading this file ==>",
        file,
        segment_id,
        topic_id,
        activeTopicIdx,
        qNo,
        props
      );
    });

    return { newFiles, extraFiles };
  };

  useEffect(() => {
    if (answerMode && stateUpdatedCount > 0) {
      if (props.onChange) {
        let result = {
          attachments_json: cloneDeep(state),
          attempt_status: cloneDeep(attemptStatus),
        };
        console.log("last result which is sent ==>", result);
        props.onChange(result);
      }
    }

    console.log(
      "on change is fired with state updated count ==>",
      stateUpdatedCount,
    );
  }, [stateUpdatedCount]);

  const saveState = (state) => {
    setMediaFormSetting({
      ...mediaFormSetting,
      okDisabled: false,
    });
    setState(state);
    console.log(
      "save state is called with stateUpdatedCount",
      stateUpdatedCount,
      state
    );
    setStateUpdatedCount((stateUpdatedCount) => stateUpdatedCount + 1);
    console.log(
      "save state is called with stateUpdatedCount",
      stateUpdatedCount,
      state
    );
  };

  const showResponseFileUploader = () => {
    setMediaFormSetting({
      ...mediaFormSetting,
      visible: true,
    });
  };

  const handleOk = () => {
    if (props.onSubmit) {
      // setMediaFormSetting({
      //   ...mediaFormInitialState,
      //   loading: true,
      // });
      if (!attachments.length) {
        message.error(mrIntl("ResponseAttachments.upload_file_eror_msg"));
        return;
      }
      props.onSubmit(state, () => {
        setMediaFormSetting({
          ...mediaFormInitialState,
          loading: true,
        });
      }, () => {
        setMediaFormSetting({
          ...mediaFormInitialState,
          loading: false,
        });
      });
    } else {
      closeModal(stateUpdatedCount);
    }
  };

  const handleRecover = () => {
    if (props.onRecoverUploads) {
      props.onRecoverUploads();
    }
  };

  const handleCancel = () => {
    setMediaFormSetting({
      ...mediaFormInitialState,
    });
    closeModal(stateUpdatedCount);
  };

  const onTabDragEnd = (attachments) => {
    const newAttachments = attachments;

    const newAttachemntsJSON = {
      ...attachments_json,
      attachments: newAttachments,
    };
    saveState(newAttachemntsJSON);
  };

  const removeItem = (index) => {
    const extra = {
      noMinSize: true,
    };
    let newRemovedAttachments = [...removedAttachments, attachments[index]];
    let newAttachments = attachments;
    newAttachments = removeItemFromArray(newAttachments, index, extra);
    const newAttachemntsJSON = {
      ...attachments_json,
      attachments: newAttachments,
      removedAttachments: newRemovedAttachments,
    };
    console.log("removeItem ==>", newAttachemntsJSON);

    const newAttachmentsCount = newAttachments.length;
    const isFilesUploaded = newAttachmentsCount ? true : false;

    if (answerMode) {
      setAttemptStatus({
        ...attemptStatus,
        files_uploaded: newAttachmentsCount,
        files_upload_attempted: isFilesUploaded,
      });
    }
    message.success(mrIntl("ResponseAttachments.delete_file_success_msg"));
    saveState(newAttachemntsJSON);
    console.log("removeItem ==>", newAttachemntsJSON, state);

  };

  const onSaveMedia = (files, extraFiles) => {
    let newAttachments = files;

    const newAttachemntsJSON = {
      ...attachments_json,
      attachments: newAttachments,
      extraAttachments: extraFiles,
    };

    const newAttachmentsCount = newAttachments.length;
    const isFilesUploaded = newAttachmentsCount ? true : false;

    if (answerMode) {
      setAttemptStatus({
        ...attemptStatus,
        files_uploaded: newAttachmentsCount,
        files_upload_attempted: isFilesUploaded,
      });
    }
    message.success(mrIntl("ResponseAttachments.add_file_success_msg"));
    saveState(newAttachemntsJSON);
  };

  const onRemoveMedia = (file) => {
    let newAttachments = attachments;
    const index = newAttachments.findIndex((atc) => atc.id == file.id);
    console.log("onRemoveMedia index ==>", newAttachments, index, file);
    if (index >= 0) {
      removeItem(index);
    }
  };
  
  const dispatch = useDispatch();
  const recoverAttachments = () => {
    dispatch(
      experienceUserActions.recoverAttachments(
        {
          experience_id: experienceUser.experience_id,
          user_id: experienceUser.user_id,
        },
        {
          success: { showMessage: true, message: mrIntl("CommonText.recovered_successfully") },
          successCallback: (response) => {
            console.log("response after upload =>", response);
            const finalExperienceUser = formatJsonApiData(
              response.data.experience_user
            );

            const newExperienceUser = {
              ...experienceUser,
              attachments_json: finalExperienceUser.attachments_json,
              attachments_count: finalExperienceUser.attachments_count,
            };
           
            dispatch(
              experienceUserActions.updateSuccess(
                { data: { experience_user: newExperienceUser } },
                { success: { showMessage: false } }
              )
            );
            setState(finalExperienceUser.attachments_json)
            setMediaFormSetting({
              ...mediaFormSetting,
              selectConfig: {
                ...mediaFormSetting.selectConfig,
                defaultFileList: finalExperienceUser.attachments_json.attachments.slice().map((atc) => {
                  if (props.deleteNotAllowedMessage) {
                    atc.notDeletable = true;
                  }
                  return atc;
                }),
              },
            });
            console.log(
              "newExperienceUser ==>",
              newExperienceUser,
              finalExperienceUser,
              state
            );
          },
        }
      )
    );
  };

  const showRecoverFilesConfirm = () => {
    showConfirmModal({
      centered: true,
      title: mrIntl("ResponseAttachments.recovering_attachments"),
      content: mrIntl("ResponseAttachments.this_will_recover_all_possible_missing_deleted_files"),
      onOk: () => {
        recoverAttachments();
      },
      mrIntl: mrIntl
    });
  };

  const onMediaOrderChange = ({ source, destination }) => {
    const newAttachments = attachments;

    const draggableItem = newAttachments[source.index];
    newAttachments.splice(source.index, 1);
    newAttachments.splice(destination.index, 0, draggableItem);

    const newAttachemntsJSON = {
      ...attachments_json,
      attachments: newAttachments,
    };
    saveState(newAttachemntsJSON);
    return newAttachments;
  };

  const onTextChanged = (type, index, data) => {
    const newAttachments = attachments;
    newAttachments[index][type] = data;

    const newAttachemntsJSON = {
      ...attachments_json,
      attachments: newAttachments,
    };
    saveState(newAttachemntsJSON);
  };

  const onTabEdit = (index, action) => {
    if (action == "add") {
    } else if (action == "remove") {
      removeItem(index);
    }
  };

  let offlineAlert;
  if (internetStatus != "online") {
    offlineAlert = (
      <Alert
        message={mrIntl("ResponseAttachments.connect_internet_to_see_file_msg")}
        banner
        closable={false}
      />
    );
  }

  const getForm = () => {
    return (
      <SelectFromComputer
        computer={true}
        url={true}
        mediaFormSetting={mediaFormSetting}
        setMediaFormSetting={setMediaFormSetting}
      />
    );
  };

  const resourceFooter = [
    <Button
      key="close-response-attachment"
      onClick={(e) => handleCancel()}
      // loading={mediaFormSetting.loading}
    >
      <MrTranslate id={"CommonText.close"}/>
    </Button>,
    // props.onRecoverUploads &&
    // <Button
    //   key="recover-response-attachment"
    //   type="primary"
    //   onClick={(e) => handleRecover()}
    //   loading={mediaFormSetting.loading}
    //   // disabled={mediaFormSetting.okDisabled}
    // >
    //   Recover
    // </Button>,
    <Button
      key="close-response-attachment"
      type="primary"
      onClick={(e) => handleOk()}
      loading={mediaFormSetting.loading}
      disabled={mediaFormSetting.okDisabled}
    >
      <MrTranslate id={"CommonText.save"}/>
    </Button>,
  ];

  const getShowView = () => {
    return (
      <div>
        <ThumbnailAttachments
          attachments={attachments}
          draggableProps={{
            isDragDisabled: true,
          }}
          listProps={{
            listType: "picture-card",
            showRemoveIcon: false,
            onPreview: mediaFormSetting.onPreview,
          }}
        />

        <PreviewAttachment
          type={previewType}
          visible={mediaFormSetting.previewCurrentFile}
          file={mediaFormSetting.previewCurrentFile}
          files={attachments}
          onCancel={() =>
            setMediaFormSetting({
              ...mediaFormSetting,
              previewCurrentFile: null,
            })
          }
        />
      </div>
    );
  };

  // const downloadAllUploads = (e) => {
  //   console.log("downloadAllUploads ==>", e);
  // };
  const attachmentCount = attachments ? attachments.length : 0;
  const isAdminOrTeacher = currentUser.role === "admin" || currentUser.role === "teacher";

  const modalTitleToRender = (
    <div className="response-attachment-title">
      <MrTranslate id={"ResponseAttachments.attachments"}/> <Tag>{attachmentCount}</Tag>
      
      {isAdminOrTeacher && (
        <>
          <ReopenUploads disabled={disableUploader} />
          <Tooltip title={disableUploader ? mrIntl("ResponseAttachments.please_unpublish_the_result_to_recover_files_tooltip") : mrIntl("ExperienceUserItemDetail.recover_files")}>
            <Button
              className="recover-upload-file-btn"
              icon={<UndoOutlined />}
              onClick={showRecoverFilesConfirm}
              disabled={mediaFormSetting.selectConfig.disabled}
            />
          </Tooltip>
        </>
      )}
      {/* <Tooltip title="Download all files">
        <Button onClick={downloadAllUploads} icon={<DownloadOutlined />} className="attachments-download-btn"/>
      </Tooltip> */}
      {/* Download API not done yet*/}
    </div>
  );

  let formToRender;
  if (modalVisible) {
    formToRender = (
      <Modal
        {...mediaFormSetting}
        open={modalVisible}
        width={checkMob() ? "" : "50%"}
        centered={checkMob() ? true : false}
        className={checkMob() ? "height-centered-modal" : ""}
        closable={false}
        maskClosable={false}
        keyboard={false}
        title={modalTitleToRender}
        // onOk={handleOk}
        // onCancel={handleCancel}
        footer={resourceFooter}
      >
        {offlineAlert}
        {getForm()}
        <br />
        <h3><MrTranslate id={"ResponseAttachments.do_not_close_this_window_while_a_file_is_uploading"}/></h3>
      </Modal>
    );
  } else {
    formToRender = getForm();
  }

  let showToRender;
  if (modalVisible && !answerMode) {
    showToRender = (
      <Modal
        open={modalVisible}
        width={checkMob() ? "" : "50%"}
        centered={checkMob() ? true : false}
        className={checkMob() ? "height-centered-modal" : ""}
        title={mrIntl("ResponseAttachments.attachments")}
        footer={null}
        onCancel={handleCancel}
      >
        {getShowView()}
      </Modal>
    );
  } else {
    showToRender = getShowView();
  }

  console.log(
    "Response attachments before render ==>",
    state,
    attachments,
    mediaFormSetting
  );
  return answerMode ? formToRender : showToRender;
};
export default ResponseAttachments;
